<template>
  <div class="btn__attach-file">
    <FontAwesomeIcon
      icon="paperclip"
      class="font-size-lg text-primary btn__icon"
      @click="$refs.file.click()"
    />
    <input v-if="multiple" ref="file" type="file" multiple @change="addFiles($event)" />

    <input v-else ref="file" type="file" @change="addFiles($event)" />
  </div>
</template>

<script>
/**
 * button that represent upload button
 * it will send user's file out by event
 * you can use with BaseFilesList component
 *
 * example: @/examples/UploadFile.vue
 *
 * ref
 * https://stackoverflow.com/questions/39577189/vuejs-trigger-input-file-from-button
 * https://stackoverflow.com/questions/41803012/v-model-doesnt-support-input-type-file
 *
 * @event add-files trigger when user upload files
 * @type {Array<File>} files that user upload
 */
import { library } from '@fortawesome/fontawesome-svg-core';
import { faPaperclip } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(faPaperclip);

export default {
  components: {
    FontAwesomeIcon
  },
  props: {
    multiple: {
      type: Boolean,
      default: true
    }
  },

  methods: {
    addFiles(event) {
      const files = event.target.files;

      this.$emit('add-files', Array.from(files));

      event.target.value = '';
    }
  }
};
</script>

<style lang="scss" scoped>
.btn__icon {
  cursor: pointer;
}

.btn__attach-file > input {
  display: none;
}
</style>
